import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { MailSettingsPaneComponent } from '../mail-settings-pane/mail-settings-pane.component';

@Component({
    selector: 'ep-mail-settings',
    templateUrl: './mail-settings.component.html',
    styleUrls: ['./mail-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, MailSettingsPaneComponent]
})
export class MailSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
